export const MaintenanceConstants = {
  UNDER_SCHEDULED_MAINTENANCE: 'under-scheduled-maintenance',
}
